import axios from "axios";

const getContextPath = function() {
  const isLocalHost = global.window?.location.host.indexOf("localhost") >= 0
  return isLocalHost ? "" : "/retrieve-saved-quotes";
};

class Config {
  constructor() {
    this.baseURL = window.location.href.indexOf('retrieve-quote.statefarm.com') > -1 ? "https://de-retrievequotes-api-prod-de-retrievequotes.digital.statefarm.com" : "https://de-retrievequotes-api-env1-de-retrievequotes.digital.test.statefarm.com";
  }

  async register() {
    try {
      const result_1 = await axios
        .get(getContextPath() + "/assets/env.json");
      if (result_1.data && result_1.data.urls) {
        this.baseURL = result_1.data.urls.baseURL;
      } else {
        this.baseURL = window.location.href.indexOf('retrieve-quote.statefarm.com') > -1 ? "https://de-retrievequotes-api-prod-de-retrievequotes.digital.statefarm.com" : "https://de-retrievequotes-api-env1-de-retrievequotes.digital.test.statefarm.com";
      }
      return await Promise.resolve();
    } catch (error) {
      this.baseURL = window.location.href.indexOf('retrieve-quote.statefarm.com') > -1 ? "https://de-retrievequotes-api-prod-de-retrievequotes.digital.statefarm.com" : "https://de-retrievequotes-api-env1-de-retrievequotes.digital.test.statefarm.com";
    }
  }
}

const getConfig = () => {
  return new Config();
};

export default getConfig();
export { getContextPath };

